import React from 'react'
import Card from './Card'
import data from './FeaturesApi'
import "./Features.css"
const Features = () => {
  return (
    <>
      <section className='features top' id="features">
        <div className='container'>
          <div className='heading'>
            <h4>Journey till now</h4>
            <h1 style={{color:'#0b6aaa'}}>Things Which I have learned till now</h1>
          </div>
          <div className='content grid'>
            {data.map((val,index)=>{
                return <Card key={index} image={val.image} title={val.title} />
            })}
          </div>
        </div>
      </section>
    </>
  )
}

export default Features
// desc={val.desc}